import { SetStateAction } from 'react'
import { SwitchButton, TabItems } from '../../../../../../../../../baseComponents/Button/SwitchButton'
import TwinTrans from '../../../../../../../../../baseComponents/TwinTrans'
import { useTabLogic } from '../../../../../../../../../utils/hooks/useTabLogic'
import { ShippingServiceExtended } from '..'
import TableShippingRates from './TableShippingRates'
import TableShippingRatesCost from './TableShippingRatesCost'
import useEditDeleteModal, { EditDeleteModalProps } from '../../../../../../../../../utils/hooks/useEditDeleteModal'
import ModalCEShippingZonesService from './MCEShippingZone'
import PermissionChecker from '../../../../../../../../../baseComponents/PermissionChecker'
import { ButtonPrimary } from '../../../../../../../../../baseComponents/Button'
import { getUserPermissions } from '../../../../../../../../../utils/reducers/getters'
import { RowData } from '../../../../../../../../../baseComponents/TwinTable/types'
import { EditRowNotLink } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'

interface SwitchTableShippingRateAndCostProps {
    dataService: ShippingServiceExtended
    setDataService: React.Dispatch<SetStateAction<ShippingServiceExtended | null>>
    getAllData: () => Promise<void>
}

const SwitchTableShippingRateAndCost: React.FC<SwitchTableShippingRateAndCostProps> = ({getAllData, ...rest }) => {
    const { active, ComponentFromTab, onChangeTabs, openModal, setOpenModal } = useSwitchTableShippingRateAndCostLogic()
    const userPermissions = getUserPermissions('config.shipping')
    const items: TabItems[] = [
        {
            element: <TwinTrans transKey={'customer'}>Cliente</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'costs'}>Costes</TwinTrans>
        }
    ]
    return (
        <div className='switch_table_shipping_rate flex-auto flex flex-col'>
            <div className='w-fit mb-30 flex gap-5'>
                <SwitchButton active={active} onClick={onChangeTabs} items={items} />
                <PermissionChecker userPermissions={userPermissions} permission='create'>
                    <ButtonPrimary type='button' onClick={() => setOpenModal({ type: 'create', allRowData: {} })}><TwinTrans transKey={'addNewShippingZone'}>Añadir nueva zona</TwinTrans></ButtonPrimary>
                </PermissionChecker>
            </div>
            <ComponentFromTab {...rest} EditComponent={ShippingRatesInputCheckCustomRender} editComponentProps={{ getAllData, openModal, setOpenModal }} />
            {openModal?.type === 'create' ? <ModalCEShippingZonesService setOpened={() => setOpenModal(null)} getAllData={getAllData} /> : null}
            {openModal?.type === 'edit' ? <ModalCEShippingZonesService setOpened={() => setOpenModal(null)} getAllData={getAllData} allRowData={openModal?.allRowData} /> : null} 
        </div>
    )
}


const useSwitchTableShippingRateAndCostLogic = () => {
    const { active, ComponentFromTab, onChangeTabs } = useTabLogic([
        {
            component: TableShippingRates,
        },
        {
            component: TableShippingRatesCost
        }
    ])
    const { openModal, setOpenModal } = useEditDeleteModal()


    return { active, ComponentFromTab, onChangeTabs, openModal, setOpenModal }
}

interface ShippingRatesInputCheckCustomRenderProps extends EditDeleteModalProps {
    parameterValue: string
    allRowData: RowData
}

const ShippingRatesInputCheckCustomRender: React.FC<ShippingRatesInputCheckCustomRenderProps> = ({ parameterValue, allRowData, setOpenModal }) => {
    return (
        <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpenModal({ type: 'edit', allRowData })} className='ml-auto' />
    )
}

export default SwitchTableShippingRateAndCost